<p-messages [value]="messages"></p-messages>
<p-table [value]="partnerList" autoLayout=true [paginator]="true" [rows]="10" [loading]="loading" [rowsPerPageOptions]="[10,25,50,100]">
    <ng-template pTemplate="header">
        <tr>
            <th [pSortableColumn]="'IsActive'">Status <p-sortIcon [field]="'IsActive'"></p-sortIcon></th>
            <th [pSortableColumn]="'RelationshipType'">Partner Type <p-sortIcon [field]="'RelationshipType'"></p-sortIcon></th>
            <th [pSortableColumn]="'CompanyName'">Partner<p-sortIcon [field]="'CompanyName'"></p-sortIcon></th>
            <th [pSortableColumn]="'UserCount'">Active User Count <p-sortIcon [field]="'UserCount'"></p-sortIcon></th>
            <th [pSortableColumn]="'PrimaryContact'">Primary Contact <p-sortIcon [field]="'PrimaryContact'"></p-sortIcon></th>
            <th [pSortableColumn]="'Phone'">Phone <p-sortIcon [field]="'Phone'"></p-sortIcon></th>
            <th [pSortableColumn]="'Email'">Email <p-sortIcon [field]="'Email'"></p-sortIcon></th>
            <th>Actions</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-partner>
        <tr>
            <td>{{partner.IsActive ? 'Active' : 'Inactive'}}</td>
            <td>{{partner.RelationshipType}}</td>
            <td><a href="{{partnerDetailsUri}}&RelationshipId={{partner.RelationshipXrefId}}">{{partner.CompanyName}}</a></td>
            <td>{{partner.UserCount}}</td>
            <td>{{partner.PrimaryContact}}</td>
            <td>{{partner.Phone | phone}}</td>
            <td>{{partner.Email}}</td>
            <td>
                <i class="pi pi-fw pi-pencil action" (click)="editPartner(partner)" *ngIf="!loading"></i>
                <i class="pi pi-fw pi-trash action" (click)="deactivatePartnerConfirm(partner)" *ngIf="!loading && partner.IsActive"></i>
            </td>
        </tr>
    </ng-template> 
</p-table> 
<div *ngIf="displayDialog">
    <app-edit-partnership [displayDialog] = "displayDialog"  [relationshipId] = "relationshipId" (onDialogClose)="dialogClose($event)" (onRelationships) = "refreshRelationships($event)" [partner] = "partnerUser" (onError)= errorMessage($event)></app-edit-partnership>
</div>
<p-confirmDialog header="Inactivate Partnership" icon="pi pi-exclamation-triangle" *ngIf="partnerList"></p-confirmDialog>

